import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

    constructor(
        private titleService: Title, 
        private matDialog: MatDialog, 
        private cookieConsentService: NgcCookieConsentService) { }

    
    ngOnInit() {

        this.titleService.setTitle('Página no encontrada :(');
        this.matDialog.closeAll();
        this.cookieConsentService.close(false);

    }

}
